import { type RomanApiError, isBadInternetConnectionError } from "@roman/shared/utils/error";
import { useCallback } from "react";

export type Toast = {
  error: (message: string, options?: { description?: string }) => void;
};

export const useHandleErrorBase = (message = "", toast: Toast = { error: () => {} }) => {
  return useCallback(
    (error: RomanApiError) => {
      if (isBadInternetConnectionError(error)) {
        // toast.error("通信エラー", {
        //   description: "より安定したネットワーク環境で再度お試しください。",
        // });
        return;
      }
      const errorCode = error.status || 400;
      toast.error(`[${errorCode}] ${message}`, {
        description: "推奨:エラーが起きた際は、ブラウザタブを一度消してリロードしてください",
      });
    },
    [message, toast.error],
  );
};
